import def from './default';
import rubicon from './rubicon';
import improvedigital from './improvedigital';
import appnexus from './appnexus';

export default {
	'default': def,
	rubicon,
	improvedigital,
	'imprweborama': improvedigital,
	appnexus,
	'gps': appnexus
};
